import React, { Fragment } from 'react'
import * as S from './style'
import Svg from '@components/svg'
import {
  booking,
  cancelledBookings,
  cashPayment,
  contact,
  onlinePayment,
  totalBus,
  totalEarnings,
  totalLocations,
  totalWithdrawal,
  wallet,
} from '@assets/icons'

import styled from '@emotion/styled'

import { useModal } from '@context/ModalContext'
import Grid from '@components/grid'
import useIsMobile from '@hooks/useIsMobile'

export const Profile = ({ user, isUser, dashboard, userDash }: any) => {
  const isMobile = useIsMobile()
  const { showModal } = useModal()

  const getValue = (value: any) => {
    return value ?? 'N/A'
  }

  const statCardData = isUser
    ? [
        {
          icon: booking,
          title: 'Total Bookings',
          amount: userDash?.totalBookings ?? 0,
        },
        {
          icon: cancelledBookings,
          title: 'Total Cancelled',
          amount: userDash?.totalCancelledBooking ?? 0,
        },
        {
          icon: booking,
          title: 'Total Completed',
          amount: userDash?.totalCompletedBooking ?? 0,
        },
      ]
    : [
        {
          icon: totalEarnings,
          title: 'Total Revenue',
          amount: dashboard?.totalRevenue ?? 0,
        },
        {
          icon: totalBus,
          title: 'Total Busses',
          amount: dashboard?.totalVehicles ?? 0,
        },
        {
          icon: totalLocations,
          title: 'Routes Setups',
          amount: dashboard?.totalRoutes ?? 0,
        },
        {
          icon: totalWithdrawal,
          title: 'Total Withdraws',
          amount: dashboard?.totalWithdrawRelease ?? 0,
        },
        {
          icon: onlinePayment,
          title: 'Online Payment',
          amount:
            (dashboard?.totalRevenue ?? 0) - (dashboard?.totalCashRevenue ?? 0),
        },
        {
          icon: cashPayment,
          title: 'Cash Payment',
          amount: dashboard?.totalCashRevenue ?? 0,
        },
      ]
  return (
    <>
      <S.StyleUserDetailWrapper isUser={isUser}>
        <S.StyleProfileWrapper>
          <S.PersonalInfo>
            <S.ProfileWrapper>
              {user?.avatar ? (
                <S.Profile
                  src={`${process.env.APP_BUCKET_URL}/${user.avatar}`}
                />
              ) : (
                <S.ProfileFallback>
                  {user?.name?.charAt(0)?.toUpperCase() || 'U'}
                </S.ProfileFallback>
              )}
            </S.ProfileWrapper>
            <S.Details>
              <S.Name>{getValue(user?.name)}</S.Name>
              <S.Number>{getValue(user?.phoneNo)}</S.Number>
              <S.Email>{getValue(user?.email)}</S.Email>
            </S.Details>
          </S.PersonalInfo>
          {!isUser && (
            <S.ActionButton
              onClick={() => {
                window.open(`tel:${user.phoneNo}`, '_self')
              }}
            >
              <Svg src={contact} styleSvg={S.translateSvg} />
              Contact Provider
            </S.ActionButton>
          )}
        </S.StyleProfileWrapper>

        {isMobile ? (
          <Grid>
            {statCardData.map((item, i) => (
              <S.StyleStatsCard key={i}>
                <S.StyleStatsCardTitleWrapper>
                  <Svg src={item.icon} styleSvg={S.translateSvg} />
                  <S.StyleStatsCardTitle>{item.title}</S.StyleStatsCardTitle>
                </S.StyleStatsCardTitleWrapper>
                <S.StyleStatsCardNumber>{item.amount}</S.StyleStatsCardNumber>
              </S.StyleStatsCard>
            ))}
          </Grid>
        ) : (
          statCardData.map((item, i) => (
            <S.StyleStatsCard key={i}>
              <S.StyleStatsCardTitleWrapper>
                <Svg src={item.icon} styleSvg={S.translateSvg} />
                <S.StyleStatsCardTitle>{item.title}</S.StyleStatsCardTitle>
              </S.StyleStatsCardTitleWrapper>
              <S.StyleStatsCardNumber>{item.amount}</S.StyleStatsCardNumber>
            </S.StyleStatsCard>
          ))
        )}
      </S.StyleUserDetailWrapper>
    </>
  )
}

const ModalTitle = styled.p`
  color: ${(props: any) => props.theme.colors.primary};
  font-size: 20px;
  text-align: center;
`
